import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AnalyticsService } from 'app/analytics/analytics.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  selector: 'cc-edit-dashboard-modal',
  templateUrl: './edit-dashboard-modal.component.html',
  styleUrls: ['./edit-dashboard-modal.component.scss'],
})
export class EditTeamDashboardModalComponent implements OnDestroy, OnInit {
  private readonly destroy$ = new Subject<void>();

  model = { name: '', id: '' };
  title = 'Add';
  hasDashboard = false;

  @Input() teamId: string;
  @Input() dashboardId: string | null;
  dashboard: Observable<any>;

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly analyticsService: AnalyticsService,
    private readonly errorHandler: ErrorHandler,
    private readonly toastrService: ToastrService,
  ) {}

  ngOnInit(): void {
    this.dashboard
      .pipe(
        filter((dashboard) => !!dashboard),
        takeUntil(this.destroy$),
      )
      .subscribe((dashboard) => {
        this.title = 'Edit';
        this.hasDashboard = true;
        this.model.name = dashboard.name;
        this.model.id = dashboard._id;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async onSubmit() {
    try {
      if (this.model.id) {
        await this.analyticsService
          .updateTeamDashboard(this.teamId, this.model.id, this.model.name)
          .toPromise();
        this.toastrService.successByKey('dashboardUpdated');
      } else {
        await this.analyticsService.addTeamDashboard(this.teamId, this.model.name).toPromise();
        this.toastrService.successByKey('dashboardAdded');
      }
    } catch (e) {
      this.errorHandler.handle(e);
    }
    this.modal.close(this.model.name);
  }
}
